<template>
  <b-navbar :fixed-top="fixedTop" :centered="centered">
    <template #brand>
      <slot name="brand" />
    </template>
    <template #start>
      <slot name="start" />
    </template>
    <template #end>
      <slot name="end" />
    </template>
    <slot />
  </b-navbar>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'NavbarView',
  slotsDefinition: {
    brand: {},
    start: {},
    end: {}
  },
  props: {
    fixedTop: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    }
  }
};
</script>
